import { render, staticRenderFns } from "./Antiques.vue?vue&type=template&id=cf71d050&scoped=true&"
import script from "./Antiques.vue?vue&type=script&lang=js&"
export * from "./Antiques.vue?vue&type=script&lang=js&"
import style0 from "./Antiques.vue?vue&type=style&index=0&id=cf71d050&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf71d050",
  null
  
)

export default component.exports